module.exports = __webpack_public_path__ + "static/media/mapVillage.8f174d44.png";